import React from "react";
import { Link, Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { LayoutDashboard, Package, Users, LogOut, ExternalLink, Phone, FileText, ShoppingBag, Store, PackagePlus } from "lucide-react";

export default function AdminShell() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const items = [
    { to: "/admin", end: true, label: "Áttekintés", icon: LayoutDashboard, testid: "admin-nav-overview" },
    { to: "/admin/products", label: "Készlet", icon: Package, testid: "admin-nav-products" },
    { to: "/admin/manual-products", label: "Manuális", icon: PackagePlus, testid: "admin-nav-manual-products" },
    { to: "/admin/orders", label: "Rendelések", icon: ShoppingBag, testid: "admin-nav-orders" },
    { to: "/admin/marketplace", label: "Piactér", icon: Store, testid: "admin-nav-marketplace" },
    { to: "/admin/customers", label: "Műhelyek", icon: Users, testid: "admin-nav-customers" },
    { to: "/admin/content", label: "Tartalom", icon: FileText, testid: "admin-nav-content" },
  ];

  const handleLogout = () => { logout(); navigate("/login"); };

  return (
    <div className="min-h-screen bg-white">
      {/* Top utility bar */}
      <div className="topbar">
        <div className="max-w-[1280px] mx-auto px-4 h-9 flex items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <Phone size={11} />
            <span>prnds24.hu — Admin felület</span>
          </div>
          <div className="text-[11px] uppercase font-bold" style={{ color: "var(--signal)" }}>
            Belső használatra · Csak adminisztrátorok számára
          </div>
        </div>
      </div>

      {/* Header */}
      <div className="bg-white border-b" style={{ borderColor: "var(--border)" }}>
        <div className="max-w-[1280px] mx-auto px-4 py-3 flex items-center justify-between gap-4">
          <Link to="/admin" data-testid="admin-brand" className="flex items-center gap-3">
            <div
              className="w-10 h-10 flex items-center justify-center rounded shrink-0"
              style={{ background: "var(--text)", color: "#fff", fontWeight: 900, fontSize: 16 }}
            >
              P24
            </div>
            <div className="leading-tight">
              <div className="font-bold text-lg">prnds24.hu</div>
              <div className="text-[11px]" style={{ color: "var(--text-mute)" }}>Adminisztrációs vezérlőpult</div>
            </div>
          </Link>
          <div className="flex items-center gap-2">
            <Link to="/catalog" className="btn-ghost !py-1 !px-2 text-[11px]" data-testid="admin-view-shop">
              <ExternalLink size={12} /> Storefront
            </Link>
            <span className="text-xs hidden sm:inline" style={{ color: "var(--text-mute)" }}>
              Üdv, <strong style={{ color: "var(--text)" }}>{user?.email}</strong>
            </span>
            <button onClick={handleLogout} className="btn-ghost !py-1 !px-2 text-[11px]" data-testid="admin-logout">
              <LogOut size={12} /> Kilépés
            </button>
          </div>
        </div>
      </div>

      {/* Brand-style admin tab nav */}
      <div className="brand-nav border-b" style={{ borderColor: "var(--border)" }}>
        <div className="max-w-[1280px] mx-auto px-4 flex items-center gap-1 overflow-x-auto whitespace-nowrap">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={it.testid}
              className="px-4 py-2.5 text-xs font-bold uppercase flex items-center gap-2"
              style={({ isActive }) => ({
                color: isActive ? "#fff" : "var(--text)",
                background: isActive ? "var(--brand)" : "transparent",
              })}
            >
              <it.icon size={13} />
              {it.label}
            </NavLink>
          ))}
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="breadcrumb">
        <div className="max-w-[1280px] mx-auto px-4">
          <Link to="/admin">Admin</Link> / <span style={{ color: "var(--text)" }}>Vezérlőpult</span>
        </div>
      </div>

      <main>
        <div className="max-w-[1280px] mx-auto px-4 py-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
